import { IView } from 'src/store/type-displayed-spinner/types';
import { EFloorType } from 'src/store/view-2d/reducer';
import { ISubViewMappingEFloorType } from 'src/typings/table';

export type CrosstableSubViewRoute = 'simple' | 'listing' | 'detailed';

const floorTypeByRoute: Record<CrosstableSubViewRoute, EFloorType> = {
  simple: EFloorType.mini,
  listing: EFloorType.list,
  detailed: EFloorType.moreInfo,
};

const routeByFloorType: Record<EFloorType, CrosstableSubViewRoute> = {
  [EFloorType.mini]: 'simple',
  [EFloorType.list]: 'listing',
  [EFloorType.moreInfo]: 'detailed',
};

export const getCrosstableFloorTypeByRoute = (
  route?: string,
): EFloorType | undefined => floorTypeByRoute[route as CrosstableSubViewRoute];

export const getCrosstableRouteByFloorType = (
  floorType: EFloorType,
): CrosstableSubViewRoute => routeByFloorType[floorType];

export const getEnabledCrosstableFloorTypes = (views: IView[]): EFloorType[] => {
  const crosstableView = views.find((view) => view.type === 'Crosstable' && view.isEnabled);

  return [...(crosstableView?.subViews || [])]
    .filter((subView) => subView.isEnabled)
    .sort((first, second) => first.sortOrder - second.sortOrder)
    .map((subView) => ISubViewMappingEFloorType[subView.type])
    .filter((floorType): floorType is EFloorType => Boolean(floorType));
};

export const resolveCrosstableFloorType = (views: IView[]): EFloorType | undefined => {
  const enabledFloorTypes = getEnabledCrosstableFloorTypes(views);

  return enabledFloorTypes[0];
};

export const resolveRoutedCrosstableFloorType = (
  views: IView[],
  routedFloorType?: EFloorType,
): EFloorType | undefined => {
  const enabledFloorTypes = getEnabledCrosstableFloorTypes(views);

  if (routedFloorType && enabledFloorTypes.includes(routedFloorType)) {
    return routedFloorType;
  }

  return enabledFloorTypes[0];
};
